import { Button } from '@zep-us/zus/button';
import { useTranslation } from 'next-i18next';
import { ChevronRightIcon } from '@/icons';
export const BuildHeaderNextButton = ({
  onClick,
  disabled
}: {
  onClick: () => void;
  disabled?: boolean;
}) => {
  const {
    t
  } = useTranslation(['build', 'common']);
  return <Button rightSlot={<ChevronRightIcon size="sm" />} size="md" disabled={disabled} onClick={onClick} data-sentry-element="Button" data-sentry-component="BuildHeaderNextButton" data-sentry-source-file="BuildHeaderNextButton.tsx">
      <span className="hidden mobile-lg:inline-block">
        {t('build:completeWriting')}
      </span>
      <span className="inline-block mobile-lg:hidden">
        {t('common:global.next.button')}
      </span>
    </Button>;
};